import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild  } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { LoadingBarService } from "@ngx-loading-bar/core";
import { ResizedEvent } from "angular-resize-event";
import * as _ from "lodash";
import { ToastrService } from "ngx-toastr";
import * as XLSX from "xlsx";
import { ClassificationExternalid } from "../../../models/classification-externalid";
import { ClassificationField } from "../../../models/classification-field";
import {ClassificationFieldExternalId} from "../../../models/classification-field-externalid";
import { ClassificationFieldTranslation } from "../../../models/classification-field-translation";
import { ClassificationGroup } from "../../../models/classification-group";
import { ClassificationType } from "../../../models/classification-type";
import { IdValue } from "../../../models/id-value";
import { Language } from "../../../models/language";
import { ClassificationControllerService } from "../../../services/classifications-controller/classification-controller.service";
import { ClassificationExternalidControllerService } from "../../../services/classifications-controller/classification-externalid-controller.service";
import { ClassificationGroupControllerService } from "../../../services/classifications-controller/classification-group-controller.service";
import { LanguageControllerService } from "../../../services/language-controller/language-controller.service";
import EXCEL_MIME_TYPES from "../../utils/excel-mime-types";
import {TranslatedBaseError} from "../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import { Service } from "../../../models/service";
import { CatalogUsage } from "../../../models/catalog-usage";
import { ServiceControllerService } from "../../../services/service-controller/service-controller.service";
import {environment} from "../../../../environments/environment";
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: "other-classification",
  templateUrl: "./other-classification.component.html",
  providers: [ToastrService],
})

export class OtherClassificationComponent extends TranslatedBaseError implements OnInit {
  public enforceCatalogLimit: number = Number(environment.CATALOGS_LIMIT_TO_ENFORCE);
  public selectedClassificationValue: any = { id: "", text: "" };
  public classifications: any[];
  public classificationFields: ClassificationField[] = [];
  public classificationTypeId: string;
  public selectedClassificationType: ClassificationType;
  public classificationTypes: ClassificationType[];
  public filteredClassificationTypes: ClassificationType[];
  @Input() public hideList: boolean = false;
  @Input() public determinantMapById: { [key: string]: string };
  @Input() public isRejectionCatalogs: boolean = false;
  @Output() public modalClosedEvent = new EventEmitter();
  @Output() public sendClassificationNumber = new EventEmitter();
  public key = "";
  public value = "";
  public groupValue = "";
  public newItemValue: string = "";
  public externalidValue = "";
  public languages: Language[] = [];
  public classificationTypesWithoutCurrent: ClassificationType[];
  public subClassificationTypes: ClassificationType[] = [];

  public showClassificationAdd: boolean = false;
  public newClassification: any = [];

  public newClassificationName: string = null;

  public groups: ClassificationGroup[] = [];
  public externalids: ClassificationExternalid[] = [];

  public sortOrder: any = { columnId: "", asc: false };
  public sortIDsOrder: any = { columnId: "", asc: false };

  public editMode: string = "";
  public editInitialName: string = "";

  public searchServiceFilterObject: any;
  public searchService: string = "";

  public searchTextFilterObject: any;
  public searchValue: string = "";
  public services: Service[];

  public usedServices: any = [];
  public areAllUsedServices: boolean = true;
  public selectedServices: any = [];

  public isDrawerClosed: boolean = true;
  public isImportDrawerClosed: boolean = true;
  public isAddNewCatalogClosed: boolean = true;

  public isLoading: boolean = false;

  public lastOrder: any = null;
  private alphabeticalOrderReference: any = { value: true, key: true };

  // fake scroll
  private isScrolled: boolean = false;
  public contentWidth: number = 0;
  @ViewChild("elementScroll") public elementScroll: ElementRef;
  @ViewChild("fakeScroll") public fakeScroll: ElementRef;

  // Pagination
  public page: number = 1;
  public pageSize: number = 30;
  public totalPages: number = 1;
  public pageFilter: string = null;
  public sortKey: string = "name";
  public asc: string = "asc";

  public subCPage: number = 1;
  public subCPageSize: number = 30;
  public subCTotalPages: number = 1;
  public subCPageFilter: string = null;
  public subCSortKey: string = "name";
  public subCAsc: string = "asc";

  public catPage: number = 0;
  public catPageSize: number = 30;
  public catTotalPages: number = 1;
  public catPageFilter: string = null;
  public catSortKey: string = "customOrder";
  public catAsc: string = "asc";

  // Pagination for classification fields display
  public fieldsPage: number = 1;
  public fieldsPageSize: number = 25;
  public fieldsAllItems: number = 0;
  private totalUnfilteredFieldsCount: number = 0;

  // Page size selector options
  public pageSizeOptions: number[] = [25, 50, 100];
  public readonly PAGE_SIZE_ALL: number = 9999;

  // Groups tab - load all fields to prevent data loss
  public allClassificationFields: ClassificationField[] = [];
  public isLoadingAllFields: boolean = false;
  public allFieldsLoaded: boolean = false;

  // Catalog usages
  public showUsagesDrawer: boolean = false;
  public showUsagesSection: boolean = false;
  public catalogUsages: CatalogUsage[] = [];
  public selectedCatalogForUsages: ClassificationType = null;
  public loadingUsages: boolean = false;
  public usagesSectionsOpen: { [key: string]: boolean } = {};
  private usagesByCatalogIdCache: { [catalogId: string]: CatalogUsage[] } = {};
  public serviceNamesCache: { [serviceId: string]: string } = {};
  public groupedUsages: {
    serviceId: string;
    serviceName: string;
    forms: { formId: string; formName: string; formType: string; usages: CatalogUsage[] }[];
    determinants: CatalogUsage[];
    parentCatalogs: CatalogUsage[];
  }[] = [];

  constructor(private classificationControllerService: ClassificationControllerService,
              private serviceControllerService: ServiceControllerService,
              private classificationGroupControllerService: ClassificationGroupControllerService,
              private classificationExternalidControllerService: ClassificationExternalidControllerService,
              private route: ActivatedRoute, private router: Router,
              private languageService: LanguageControllerService, toastr: ToastrService,
              private loadingBar: LoadingBarService,
              public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceControllerService.getServicesList().subscribe(
        (data: Service[]) => {
          this.services = data;
          this.loadClassificationTypes();
          this.loadLanguages();
        });
    });
  }

  public goToBackList() {
    this.hideList = false;
    this.route.params.subscribe((params) => {
      if (params && params.catalogueId) {
        window.location.replace("/variables/instance-catalogs");
      } else {
        history.back();
        this.loadClassificationTypes();
      }
    });
  }

  public dropped(event: CdkDragDrop<ClassificationField[]>) {
    console.log("Dropped event:", event);
    // Prevent reordering when filter is active - indices would be incorrect
    if (this.catPageFilter) {
      this.toastr.warning(this.translate("Clear the search filter before reordering items"));
      return;
    }
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      // component logic — account for page offset so customOrder is globally correct
      const offset = (this.fieldsPage - 1) * this.fieldsPageSize;
      this.classificationFields[event.currentIndex].customOrder = offset + event.currentIndex;
      this.updateClassificationField(this.classificationFields[event.currentIndex]);
      //this.saveClassificationFields();
    }
  }

  public droppedGroups(event: CdkDragDrop<ClassificationGroup[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      this.groups.forEach((group, index, groupsArray) => {
        groupsArray[index].sortOrder = index;
      });
      this.sortGroups();
    }
  }

  public droppedExternalid(event: CdkDragDrop<ClassificationExternalid[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }
  }

  public toggleUsedService(item) {
    item.isActive = !item.isActive;
    if (!item.isActive) {
      this.areAllUsedServices = false;
    } else {
      if (this.checkAllUsedServices()) {
        this.areAllUsedServices = true;
      }
    }
    this.filterCatalogs();
  }

  public checkAllUsedServices() {
    return !this.usedServices.find((s) => !s.isActive);
  }

  public toggleAllUsedService() {
    this.areAllUsedServices = !this.areAllUsedServices;
    this.usedServices.forEach((service) => {
      service.isActive = this.areAllUsedServices;
    });
    this.filterCatalogs(!this.areAllUsedServices);
  }

  public filterCatalogs(noservices: boolean = false) {
    if (noservices) {
      this.filteredClassificationTypes = this.classificationTypes.filter((c) => {
        return !c.serviceIds || !c.serviceIds.length;
      });
    } else if (this.checkAllUsedServices()) {
      this.filteredClassificationTypes = this.classificationTypes;
    } else {
      this.filteredClassificationTypes = this.classificationTypes.filter((c) => {
        return c.serviceIds && c.serviceIds.find((s) => {
          return this.usedServices.find((ss) => ss.isActive && s === ss.id);
        });
      });
    }
  }

  public updatePage(e: any) {
    if (e && e.trigger === "page") {
      this.page = e.page;
    }
    if (e && e.trigger === "search") {
      this.page = e.page;
      this.pageFilter = e.filter;
    }
    if (e && e.trigger === "sort") {
      this.sortKey = e.sortKey;
      this.asc = e.asc;
    }
    this.loadClassificationTypes(this.page, this.pageSize, this.pageFilter, this.sortKey, this.asc);
  }

  public searchSubCatalogs(e) {
    if (!e.term.includes(this.subCPageFilter)) {
      this.subCPage = 1;
      this.subClassificationTypes = [];
    }
    this.subCPageFilter = e.term;
    this.loadSubClassificationTypes(this.subCPage, this.subCPageSize, this.subCPageFilter, this.subCSortKey, this.subCAsc);
  }

  public scrollNextPage() {
    this.subCPage ++;
    this.loadSubClassificationTypes(this.subCPage, this.subCPageSize, this.subCPageFilter, this.subCSortKey, this.subCAsc);
  }

  public loadClassificationTypes(page: number = this.page, size: number = this.pageSize, filter: string = this.pageFilter, sortKey: string = this.sortKey, asc: string = this.asc) {
    this.route.params.subscribe((params) => {
      if (params && params.catalogueId) {
        this.classificationControllerService.getClassificationTypeById(params.catalogueId).subscribe((data) => {
          this.loadEditClassificationType(data);
        });
      } else {
        this.classificationControllerService.getClassificationTypesByPage((page - 1 > -1 ? page - 1 : 0), size, filter, sortKey, asc, this.isRejectionCatalogs).subscribe(
          (data) => {
            this.classificationTypes = data.content;
            this.sendClassificationNumber.emit(data?.totalElements);
            this.totalPages = data.totalPages;
            if (data.totalElements > data.size) {
              this.page = data.number + 1;
            }
            this.filteredClassificationTypes = this.classificationTypes;
            // Load usages counts for all catalogs
            this.loadUsagesCounts();
          },
          (error) => this.showErrorMessage(error),
        );
      }
    });
  }

  /**
   * Loads usages counts for all catalogs in the current list
   */
  private loadUsagesCounts(): void {
    if (!this.classificationTypes || this.classificationTypes.length === 0) {
      return;
    }
    const catalogIds = this.classificationTypes.map(c => c.id);
    this.classificationControllerService.getClassificationUsages(catalogIds).subscribe(
      (usages: CatalogUsage[]) => {
        // Cache full results by catalogId
        this.usagesByCatalogIdCache = {};
        usages.forEach(usage => {
          if (usage.catalogId) {
            if (!this.usagesByCatalogIdCache[usage.catalogId]) {
              this.usagesByCatalogIdCache[usage.catalogId] = [];
            }
            this.usagesByCatalogIdCache[usage.catalogId].push(usage);
          }
        });

        // Group usages by catalogId and count unique usages
        const usageCountMap: { [key: string]: Set<string> } = {};
        usages.forEach(usage => {
          if (usage.catalogId) {
            if (!usageCountMap[usage.catalogId]) {
              usageCountMap[usage.catalogId] = new Set<string>();
            }
            // Create unique key based on usage type
            let uniqueKey = '';
            if (usage.formId) {
              uniqueKey = `form-${usage.formId}-${usage.componentKey || ''}`;
            } else if (usage.determinantId) {
              uniqueKey = `det-${usage.determinantId}`;
            } else if (usage.parentCatalogId) {
              uniqueKey = `parent-${usage.parentCatalogId}-${usage.parentCatalogFieldId || ''}`;
            }
            if (uniqueKey) {
              usageCountMap[usage.catalogId].add(uniqueKey);
            }
          }
        });
        // Update classification types with unique usage counts
        this.classificationTypes.forEach(ct => {
          (ct as any).usagesCount = usageCountMap[ct.id]?.size || 0;
        });
        // Trigger change detection by reassigning
        this.filteredClassificationTypes = [...this.classificationTypes];
      },
      (error) => {
        // Silently fail - usages are optional
        console.warn('Failed to load catalog usages:', error);
      }
    );
  }

  public loadSubClassificationTypes(page: number = this.subCPage, size: number = this.subCPageSize, filter: string = this.subCPageFilter, sortKey: string = this.subCSortKey, asc: string = this.subCAsc) {
    this.classificationControllerService.getClassificationTypesByPage((page - 1 > -1 ? page - 1 : 0), size, filter, sortKey, asc, this.isRejectionCatalogs).subscribe(
      (data) => {
        // this.subClassificationTypes = [...new Set(this.subClassificationTypes.concat(data.content))];
        this.subClassificationTypes = [...new Map(this.subClassificationTypes.concat(data.content).map((m) => [m.id, m])).values()];
        this.subCTotalPages = data.totalPages;
        if (data.totalElements > data.size) {
          this.subCPage = data.number + 1;
        }
        if (data.content.length) {
          this.classificationTypesWithoutCurrent = this.subClassificationTypes.filter((classificationType) => {
            return classificationType !== this.selectedClassificationType;
          });
        }
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public loadLanguages() {
    this.languageService.getLanguages().subscribe(
      (data) => this.languages = data,
      (error) => this.showErrorMessage(error),
    );
  }

  public loadGroups() {
    this.classificationGroupControllerService.getClassificationsGroupsByType(this.classificationTypeId).subscribe(
      (data) => {
        this.groups = data.sort((a, b) => {
          return a.sortOrder - b.sortOrder;
        });
        this.doubleScroll(document.getElementById("groupTable"));
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public loadExternalids() {
    this.classificationExternalidControllerService.getClassificationsExternalidsByType(this.classificationTypeId).subscribe(
      (data) => {
        this.externalids = data.sort((a, b) => {
          return a.sortOrder - b.sortOrder;
        });
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public buildDropDown(classifications: ClassificationType[]) {
    this.classifications = [];
    for (const classification of classifications) {
      const idValue = new IdValue();
      idValue.id = classification.id;
      idValue.text = classification.name;
      this.classifications.push(idValue);
    }
    if (this.selectedClassificationValue && !this.selectedClassificationValue.id) {
      this.selected(this.classifications.find((o) => o.text === this.selectedClassificationValue.text));
    }
  }

  public selected(idValue: IdValue): void {
    if (idValue) {
      this.selectedClassificationValue = idValue;
      this.classificationTypeId = idValue.id;
      this.selectedClassificationType = this.classificationTypes.find((o) => o.id === idValue.id);
      this.classificationTypesWithoutCurrent = this.classificationTypes.filter((classificationType) => {
        return classificationType !== this.selectedClassificationType;
      });
      this.classificationFields = [];
      this.classificationControllerService.getClassificationsByType(idValue.id).subscribe(
        (data) => this.setFields(data),
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public setFields(data) {
    // fixme limit classification fields until catalogs field refactored
    if (!isNaN(this.enforceCatalogLimit) && this.enforceCatalogLimit !== 0) {
      this.classificationFields = _.orderBy(data, ["customOrder"], ["asc"]).slice(0, this.enforceCatalogLimit);
    } else {
      this.classificationFields = _.orderBy(data, ["customOrder"], ["asc"]);
    }
    if (data.length) {
      data.forEach((d) => {
        if (d.childClassificationType) {
          this.classificationTypesWithoutCurrent.push(d.childClassificationType);
        }
      });
    }
  }


  public trackByFn(index, item) {
    return item && item.id; // or item.id
  }

  public selectedSubClassification(selectedField: ClassificationField, classification) {
    selectedField.childClassificationType = classification;
    this.updateClassificationField(selectedField);
  }

  public getTranslation(lan: string, id: string): string {
    let result;
    for (const classificationField of this.classificationFields) {
      if (classificationField.id === id) {
        for (const classificationFieldTranslation of classificationField.translations) {
          if (lan === classificationFieldTranslation.languageCode) {
            result = classificationFieldTranslation.name;
          }
        }
      }
    }
    return result;
  }

  public setTranslation(value: any, lan: string, id: string): void {
    let isUpdated = false;
    for (const classificationField of this.classificationFields) {
      if (classificationField.id === id) {
        for (const classificationFieldTranslation of classificationField.translations) {
          if (lan === classificationFieldTranslation.languageCode) {
            classificationFieldTranslation.name = value;
            isUpdated = true;
          }
        }
        if (isUpdated === false) {
          const translation = new ClassificationFieldTranslation();
          translation.name = value;
          translation.languageCode = lan;
          classificationField.translations.push(translation);
        }
      }
    }
  }

  public saveClassificationType(includeFields) {
    this.classificationControllerService.updateClassificationType(this.selectedClassificationType).subscribe(
      (data) => {
        if (includeFields) {
          this.loadClassificationFields();
        }
        this.responseSuccessful("Classification type saved!");
      },
      (error) => this.showErrorMessage(error),
      );
  }

  public triggerDownload(filename: string, content: string): void {
    const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  public copyClassification() {
    this.classificationControllerService.copyClassification(this.classificationTypeId).subscribe(
      (data) => {
        this.responseSuccessful("Service copied successfully!");
        this.loadClassificationTypes();
      },
      (error) => {
        this.showErrorMessage(error);
      },
    );
  }

  public exportToCSV() {
    this.classificationControllerService.exportClassificationCSV(this.classificationTypeId).subscribe(
      (data) => {
        console.log("--- Exported data:", data);
        this.responseSuccessful("Service exported successfully!");
        this.triggerDownload(this.selectedClassificationType.name.replace(" ", "-") + ".csv", data);
      },
      (error) => {
        this.showErrorMessage(error);
      },
    );
  }

  public importCSVFile(e) {
    e.preventDefault();
    e.stopPropagation();
    const fileInputElement = document.createElement("input");
    fileInputElement.type = "file";
    const onError = (error: any) => {
      this.loadingBar.complete();
      this.showErrorMessage(error);
    };
    // @ts-ignore
    fileInputElement.click(e);
    fileInputElement.onchange = () => {
      try {
        if (fileInputElement.files.length !== 1) {
          throw new Error("Cannot use multiple files");
        }
        if (!EXCEL_MIME_TYPES.some((excelMime) => {
          return fileInputElement.files[0].type === excelMime;
        })) {
          throw new Error("Invalid file format");
        }
        const reader: FileReader = new FileReader();
        reader.onload = async (re) => {
          try {
            const wb: XLSX.WorkBook = XLSX.read(re.target.result, {type: "binary"});

            const wsname: string = wb.SheetNames[0];
            const ws: XLSX.WorkSheet = wb.Sheets[wsname];

            const xlsxData = (XLSX.utils.sheet_to_json(ws, {header: 1, blankrows: false})); // Array of Arrays

            const cfs: ClassificationField[] = [];
            for (let i = 0; i < xlsxData.length; i++) {
              const row = xlsxData[i];
              const indexOffset = this.selectedClassificationType.useCustomKey ? 1 : 0;
              if (
                (this.selectedClassificationType.useCustomKey && i === 0 &&
                  (typeof row[0] === "string" && row[0].toLowerCase() === "key") &&
                  (typeof row[1] === "string" && row[1].toLowerCase() === "value") &&
                  (typeof row[2] === "string" && row[2].toLowerCase() === "level") &&
                  (typeof row[3] === "string" && row[3].toLowerCase() === "parent")) ||
                  (!this.selectedClassificationType.useCustomKey && i === 0 &&
                  (typeof row[0] === "string" && row[0].toLowerCase() === "value") &&
                  (typeof row[1] === "string" && row[1].toLowerCase() === "level") &&
                  (typeof row[2] === "string" && row[2].toLowerCase() === "parent"))) {
                continue;
              }
              const item: ClassificationField = new ClassificationField();
              if (this.selectedClassificationType.useCustomKey) {
                if (row[0]) {
                  item.key = row[0];
                }
              }
              item.value = row[indexOffset];
              item.catalogLevel = row[indexOffset + 1];
              item.relationKey = row[indexOffset + 2];
              item.type = "catalogValue";
              item.customOrder = i + 1;
              item.translations = this.setImportedTranslations(row, item, indexOffset + 3);
              cfs.push(item);
            }
            await this.classificationControllerService.addSubCatalogs(this.selectedClassificationType.id, cfs).toPromise();
            this.loadEditClassificationType(this.selectedClassificationType);
            this.loadingBar.complete();
          } catch (err) {
            onError(err);
          }
        };
        reader.readAsBinaryString(fileInputElement.files[0]);
      } catch (err) {
        onError(err);
      }
    };
  }

  public setImportedTranslations(row: any, item: any, index: number) {
    const translations = [];
    this.languages.map((l, i) => {
      const translation = new ClassificationFieldTranslation();
      translation.name = row[i + index];
      translation.languageCode = l.code;
      translations.push(translation);
    });
    return translations;
  }

  public generateCustomKeys() {
    this.classificationControllerService.generateCustomKeys(this.classificationTypeId).subscribe(
      (data) => {
        this.responseSuccessful("Keys generated successfully!");
        this.classificationFields = data;
        this.classificationFields.sort((a, b) => a.customOrder - b.customOrder);
      },
      (error) => {
        this.showErrorMessage(error);
      },
    );
  }


  public filterUndeletableItems(cat, item) {
    return cat && item && cat.id !== "default_rejection_reasons" &&
      item.id !== "DIV" &&
      item.id !== "DII" &&
      item.id !== "DIM" &&
      item.id !== "other";
  }

  public addNewClassificationField() {
    if (this.newItemValue && this.newItemValue.length > 0) {
      const classificationField = new ClassificationField();
      classificationField.key = this.key || this.newItemValue;
      classificationField.value = this.newItemValue;
      classificationField.customOrder = this.totalUnfilteredFieldsCount + 1;
      this.classificationControllerService.saveDocumentClassificationField(this.classificationTypeId, classificationField).subscribe(
        (data) => {
          console.log("--- Added new classification field:", data);
          this.key = "";
          this.newItemValue = "";
          // Navigate to the last page so the user sees the new item
          const lastPage = Math.ceil((this.totalUnfilteredFieldsCount + 1) / this.fieldsPageSize);
          this.fieldsPage = lastPage;
          this.responseSuccessful(this.translateService.instant("New item added on page {{page}}!").replace("{{page}}", String(lastPage)));
          this.loadClassificationFields();
          // Reset allFieldsLoaded so Groups tab will reload with new item
          this.allFieldsLoaded = false;
        },
        (error) => {
          this.showErrorMessage(error);
        }
      );
    }
  }

  public updateClassificationField(classificationField: ClassificationField, refresh: boolean = false) {
    this.classificationControllerService.saveDocumentClassificationField(this.classificationTypeId, classificationField).subscribe(
      (data) => {
        console.log("--- Updated classification field:", data);
        this.responseSuccessful("Item updated!");
        if (refresh) {
          this.loadClassificationFields();
        }
        // Reset allFieldsLoaded so Groups tab will reload with updated item
        this.allFieldsLoaded = false;
      },
      (error) => {
        this.showErrorMessage(error);
      }
    );
  }

  public removeClassificationField(isConfirmed, id: string) {
    if (isConfirmed) {
      this.classificationControllerService.deleteClassificationField(id).subscribe(
        () => {
          this.responseSuccessful("Item removed!");
          this.allFieldsLoaded = false;
          this.loadClassificationFields();
        },
        (error) => {
          this.showErrorMessage(error);
          this.loadClassificationFields();
        }
      );
    }
  }

  public createClassificationType(classificationData) {
    if (classificationData?.name) {
      this.newClassificationName = classificationData?.name;
    }
    this.isAddNewCatalogClosed = false;
  }

  public saveNewClassification() {
    this.isLoading = true;
    const classificationType = new ClassificationType();
    classificationType.name = this.newClassificationName;
    classificationType.isRejectionCatalog = this.isRejectionCatalogs;
    this.classificationControllerService.createClassificationType(classificationType).subscribe(
      (data) => {
        this.responseSuccessful("Catalogue added!");
        this.loadClassificationTypes();
        this.loadEditClassificationType(data);
        this.newClassificationName = null;
        this.isAddNewCatalogClosed = true;
      },
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
      () => this.isLoading = false,
    );
  }

  public cancelNewClassification() {
    this.newClassificationName = null;
    this.isAddNewCatalogClosed = true;
  }

  public classificationTypeWindowSubmitted(event) {
    if (event.save === true) {
      const classificationType = event.classificationType;
      const idValue = new IdValue();
      idValue.id = classificationType.id;
      idValue.text = classificationType.name;
      this.selectedClassificationValue = idValue;
    } else {
      this.selectedClassificationValue = this.classifications[0];
      this.classificationFields = [];
    }
    this.selected(this.selectedClassificationValue);
  }

  public onFileChange(evt: any) {
    this.loadingBar.start();
    /* wire up file reader */
    const target: DataTransfer = (evt.target) as DataTransfer;
    const onError = (e) => {
      this.loadingBar.complete();
      evt.target.value = ""; // clear input
      this.showErrorMessage(e);
    };
    try {
      if (target.files.length !== 1) {
        throw new Error("Cannot use multiple files");
      }
      if (!EXCEL_MIME_TYPES.some((excelMime) => {
        return target.files[0].type === excelMime;
      })) {
        throw new Error("Invalid file format");
      }
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        try {
          /* read workbook */
          const bstr: string = e.target.result;
          const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });

          /* grab first sheet */
          const wsname: string = wb.SheetNames[0];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];

          /* save data */
          const xlsxData = (XLSX.utils.sheet_to_json(ws, { header: 1, blankrows: false })); // Array of Arrays
          /*
            rows must keep structure of model, each row is Array:
            0-key
            1 - value
            ignore childClassificationType type for now
            2 - trans one
            3 - trans two
            ...

          */
          const indexOffset = this.selectedClassificationType.useCustomKey ? 1 : 0;
          const newFields: ClassificationField[] = [];
          xlsxData.forEach((row: any) => {
            if (!row[0]) { return; }
            // Check if we have that value already
            if (this.classificationFields.some((field) => {
              return field.key === row[0];
            })) {
              return;
            }
            const classificationField = new ClassificationField();
            if (this.selectedClassificationType.useCustomKey) {
              classificationField.key = row[0];
            }
            classificationField.value = row[indexOffset];
            if (this.languages && row.length > (1 + indexOffset)) {
              classificationField.translations = this.languages.map((lang, idx) => {
                const translationValue = row[idx + 1 + indexOffset];
                const t = new ClassificationFieldTranslation();
                t.name = translationValue;
                t.languageCode = lang.code; // assume the order from cols
                return t;
              });
            }
            newFields.push(classificationField);
          });
          this.loadingBar.complete();
          evt.target.value = ""; // clear input
          if (newFields.length === 0) { return; }
          const saveRequests = newFields.map(field =>
            this.classificationControllerService.saveDocumentClassificationField(this.classificationTypeId, field)
          );
          forkJoin(saveRequests).subscribe(
            (saved) => {
              this.responseSuccessful(this.translateService.instant("{{count}} items imported!").replace("{{count}}", String(saved.length)));
              this.loadClassificationFields();
              this.allFieldsLoaded = false;
            },
            (error) => {
              this.showErrorMessage(error);
              this.loadClassificationFields();
              this.allFieldsLoaded = false;
            }
          );
        } catch (err) {
          onError(err);
        }
      };
      reader.readAsBinaryString(target.files[0]);
    } catch (e) {
      onError(e);
    }
  }

  public deleteClassificationType(classificationType) {
    if (!Array.isArray(classificationType)) {
      this.classificationControllerService.deleteClassificationType(classificationType.id).subscribe(
        (data) => {
          this.classificationTypes = this.classificationTypes.filter((item) => item.id !== classificationType.id);
          this.filterCatalogs();
          this.responseSuccessful("Item removed!");
        },
        (error) => this.showErrorMessageWithTitle("Error with Service saving", error),
      );
    } else {
      const promises = [];
      classificationType.forEach((c) => {
        promises.push(
          this.classificationControllerService.deleteClassificationType(c.id).pipe(map(
            (data) => {
              return {id: c.id, data};
            },
          )).toPromise(),
        );
      });
      Promise.all<any[]>(promises).then((results: any[]) => {
        this.responseSuccessful("Catalogs deleted!");
        results.forEach((r) => {
          this.classificationTypes = this.classificationTypes.filter((item) => item.id !== r.id);
        });
        this.filterCatalogs();
      });
    }
  }

  public loadEditClassificationType(classificationType) {
    console.log("Loading classification type: ", classificationType);
    this.hideList = true;
    this.selectedClassificationValue = classificationType.id;
    this.classificationTypeId = classificationType.id;
    this.selectedClassificationType = classificationType;
    this.selectedClassificationType.useCustomOrder = true;
    this.classificationFields = [];
    this.classificationTypesWithoutCurrent = [];

    // Reset Groups tab cache so it reloads for the new catalog
    this.allFieldsLoaded = false;
    this.allClassificationFields = [];

    // Reset usages for new catalog
    this.catalogUsages = [];
    this.groupedUsages = [];

    // Reset pagination to first page
    this.fieldsPage = 1;

    this.loadClassificationFields();
    this.loadGroups();
    this.loadExternalids();
    this.loadCatalogUsages(classificationType.id);
    this.route.params.subscribe((params) => {
      if (params && !params.catalogueId) {
        history.pushState(null, "", window.location.pathname + "/" + classificationType.id);
      }
    });
  }

  public loadClassificationFields() {
    // Calculate page number for API (0-indexed)
    const apiPage = this.fieldsPage - 1;

    this.classificationControllerService.getClassificationsByPage(
      this.classificationTypeId,
      apiPage,
      this.fieldsPageSize,
      this.catPageFilter,
      this.catSortKey,
      this.catAsc
    ).subscribe(
      (data) => {
        console.log("---- Loaded classification fields: ", data);
        // Handle paginated response
        const fields = data.content || data;
        this.classificationFields = fields;

        // Update pagination metadata
        this.fieldsAllItems = data.totalElements || fields.length;
        this.catTotalPages = data.totalPages || 1;

        // Track unfiltered total so new items always get correct customOrder
        if (!this.catPageFilter) {
          this.totalUnfilteredFieldsCount = this.fieldsAllItems;
        }

        if (fields.length) {
          fields.forEach((d) => {
            if (d.childClassificationType) {
              this.classificationTypesWithoutCurrent.push(d.childClassificationType);
            }
          });
        }
      },
      (error) => this.showErrorMessage(error),
    );
  }

  /**
   * Load ALL classification fields for the Groups tab.
   * This prevents data loss when saving group assignments across multiple pages.
   */
  public loadAllClassificationFields() {
    if (this.allFieldsLoaded && this.allClassificationFields.length > 0) {
      // Already loaded, no need to reload
      return;
    }

    this.isLoadingAllFields = true;
    this.classificationControllerService.getClassificationsByType(this.classificationTypeId).subscribe(
      (data) => {
        this.allClassificationFields = data;
        this.allClassificationFields.sort((a, b) => a.customOrder - b.customOrder);
        this.allFieldsLoaded = true;
        this.isLoadingAllFields = false;
      },
      (error) => {
        this.showErrorMessage(error);
        this.isLoadingAllFields = false;
      },
    );
  }

  /**
   * Called when switching to Groups tab - ensures all fields are loaded
   */
  public onGroupsTabSelected() {
    this.loadAllClassificationFields();
  }

  /**
   * Reload all fields after a save operation to keep data in sync
   */
  public reloadAllClassificationFields() {
    this.allFieldsLoaded = false;
    this.loadAllClassificationFields();
  }

  public editClassificationType() {
    if (this.selectedClassificationType && this.selectedClassificationType.name && this.selectedClassificationType.name.length >= 2) {
      this.classificationControllerService.updateClassificationType(this.selectedClassificationType).subscribe(
        (data) => this.responseSuccessful("Catalogue updated!"),
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service ", error),
      );
    }
  }

  /**
   * Get fields filtered by searchValue (same logic as catalogFilter pipe).
   * When searchValue is empty, returns all fields.
   */
  private getFilteredFields(): ClassificationField[] {
    const fields = this.allClassificationFields.length > 0 ? this.allClassificationFields : this.classificationFields;
    if (!this.searchValue) {
      return fields;
    }
    const searchStringFormatted = this.searchValue.toLowerCase();
    return fields.filter((it) => {
      const name = it.value ? it.value.toLowerCase().includes(searchStringFormatted) : false;
      const key = it.key ? it.key.toLowerCase().includes(searchStringFormatted) : false;
      return name || key;
    });
  }

  public getGroupNumber(groupId: string) {
    let counter = 0;
    // Use allClassificationFields to count across ALL items, not just current page
    const fields = this.allClassificationFields.length > 0 ? this.allClassificationFields : this.classificationFields;
    for (const classificationField of fields) {
      for (const classificationFieldGroup of classificationField.classificationGroups) {
        if (groupId === classificationFieldGroup.id) {
          counter++;
        }
      }
    }
    return counter;
  }

  public getAllGroupValue(groupId: string) {
    // Use allClassificationFields to check across ALL items, not just current page
    const fields = this.allClassificationFields.length > 0 ? this.allClassificationFields : this.classificationFields;
    for (const classificationField of fields) {
      for (const classificationFieldGroup of classificationField.classificationGroups) {
        if (groupId === classificationFieldGroup.id) {
          return true;
        }
      }
    }
    return false;
  }

  public getGroupToggleState(groupId: string): 'none' | 'partial' | 'all' {
    // Use filtered fields when searchValue is active, so toggle state reflects only visible items
    const fields = this.getFilteredFields();
    const total = fields.length;
    if (total === 0) { return 'none'; }
    // Count assigned items within filtered fields only
    let assigned = 0;
    for (const field of fields) {
      if (field.classificationGroups.some(g => g.id === groupId)) {
        assigned++;
      }
    }
    if (assigned === 0) { return 'none'; }
    if (assigned >= total) { return 'all'; }
    return 'partial';
  }
  public getGroupValue(groupId: string, fieldId: string) {
    // Use allClassificationFields to check across ALL items, not just current page
    const fields = this.allClassificationFields.length > 0 ? this.allClassificationFields : this.classificationFields;
    for (const classificationField of fields) {
      if (classificationField.id === fieldId) {
        for (const classificationFieldGroup of classificationField.classificationGroups) {
          if (groupId === classificationFieldGroup.id) {
            return true;
          }
        }
      }
    }
    return false;
  }
  public setAllGroupValue(groupId: string) {
    const groupValue = this.getGroupToggleState(groupId) !== 'all';
    // Use filtered fields when searchValue is active, so toggle only affects visible items
    const fields = this.getFilteredFields();
    const changedFields: ClassificationField[] = [];
    for (const classificationField of fields) {
      const group = this.groups.find(g => g.id === groupId);
      if (!group) { continue; }
      const current = this.getGroupValue(groupId, classificationField.id);
      if (current !== groupValue) {
        if (groupValue) {
          classificationField.classificationGroups.push(group);
        } else {
          classificationField.classificationGroups.splice(
            classificationField.classificationGroups.findIndex((g) => g.id === group.id), 1);
        }
        changedFields.push(classificationField);
      }
    }
    if (changedFields.length === 0) { return; }
    this.isLoading = true;
    const requests = changedFields.map(f =>
      this.classificationControllerService.saveDocumentClassificationField(this.classificationTypeId, f)
    );
    forkJoin(requests).subscribe(
      () => {
        this.responseSuccessful("Group distribution saved!");
        this.allFieldsLoaded = false;
        this.loadClassificationFields();
      },
      (error) => { this.showErrorMessage(error); },
      () => { this.isLoading = false; }
    );
  }
  public setSetGroupValue(groupId: string, fieldId: string) {
    const fields = this.allClassificationFields.length > 0 ? this.allClassificationFields : this.classificationFields;
    const targetField = fields.find(f => f.id === fieldId);
    if (!targetField) { return; }
    const value = !this.getGroupValue(groupId, fieldId);
    const group = this.groups.find(g => g.id === groupId);
    if (!group) { return; }
    if (value) {
      targetField.classificationGroups.push(group);
    } else {
      targetField.classificationGroups.splice(
        targetField.classificationGroups.findIndex(g => g.id === group.id), 1
      );
    }
    this.updateClassificationField(targetField);
  }

  public addNewClassificationGroup() {
    if (!this.isLoading) {
      if (this.groupValue && this.groupValue.length >= 1) {
        this.isLoading = true;
        const classificationGroup = new ClassificationGroup();
        classificationGroup.name = this.groupValue;
        classificationGroup.classificationTypeId = this.classificationTypeId;
        classificationGroup.sortOrder = this.groups && this.groups.length && (Math.max(...this.groups.map((a) => a.sortOrder)) + 1) || 0;
        this.classificationGroupControllerService.createClassificationGroup(this.classificationTypeId, classificationGroup).subscribe(
          (data) => {
            this.responseSuccessful("Group is added!");
            this.groupValue = "";
            this.loadGroups();
          },
          (error) => this.showErrorMessage(error),
          () => this.isLoading = false,
        );
      }
    }

  }

  public editClassificationGroup(classificationGroup: ClassificationGroup) {
    if (classificationGroup.id) {
      this.classificationGroupControllerService.updateClassificationGroup(classificationGroup).subscribe(
        (data) => {
          this.responseSuccessful("Group is edited!");
          this.resetEdit();
          this.loadGroups();
        },
        (error) => this.showErrorMessage(error),
      );
    } else {
      this.classificationGroupControllerService.createClassificationGroup(this.classificationTypeId, classificationGroup).subscribe(
        (data) => {
          this.responseSuccessful("Group is edited!");
          this.resetEdit();
          this.loadGroups();
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public deleteClassificationGroup(isConfirmed: boolean, group: ClassificationGroup) {
    if (isConfirmed) {
      this.classificationGroupControllerService.deleteClassificationGroup(group.id).subscribe(
        (data) => {
          this.responseSuccessful("Group is deleted!");
          this.loadGroups();
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public setVisibility(group: ClassificationGroup) {
    group.visible = !group.visible;
    this.classificationGroupControllerService.updateClassificationGroup(group).subscribe(
      (data) => {
        this.responseSuccessful("Group is edited!");
        this.loadGroups();
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public getExtenalidValue(externalid: string, fieldId: string) {
    let result = "";
    for (const classificationField of this.classificationFields) {
      if (classificationField.id === fieldId) {
        for (const classificationFieldExternalid of classificationField.classificationFieldExternalIdList) {
          if (externalid === classificationFieldExternalid.externalIdId) {
            result =  classificationFieldExternalid.value;
          }
        }
      }
    }
    return result;
  }

  public setSetExternalidValue(event: any, eid: string, fieldId: string) {
    const targetField = this.classificationFields.find(f => f.id === fieldId);
    if (!targetField) { return; }
    const found = targetField.classificationFieldExternalIdList.find(el => el.externalIdId === eid);
    if (found) {
      found.value = event.target.value;
    } else {
      const externalId = new ClassificationFieldExternalId();
      externalId.value = event.target.value;
      externalId.externalIdId = eid;
      externalId.classificationId = fieldId;
      targetField.classificationFieldExternalIdList.push(externalId);
    }
    this.updateClassificationField(targetField);
  }

  public addNewClassificationExternalid() {
    if (!this.isLoading) {
      if (this.externalidValue && this.externalidValue.length >= 2) {
        this.isLoading = true;
        const classificationExternalid = new ClassificationExternalid();
        classificationExternalid.name = this.externalidValue;
        classificationExternalid.classificationTypeId = this.classificationTypeId;
        classificationExternalid.sortOrder = this.externalids.length;
        this.classificationExternalidControllerService.createClassificationExternalid(this.classificationTypeId, classificationExternalid).subscribe(
          (data) => {
            this.responseSuccessful("Externalid is added!");
            this.externalidValue = "";
            this.loadExternalids();
          },
          (error) => this.showErrorMessage(error),
          () => this.isLoading = false,
        );
      }
    }

  }

  public editClassificationExternalid(classificationExternalid: ClassificationExternalid) {
    if (classificationExternalid.id) {
      this.classificationExternalidControllerService.updateClassificationExternalid(classificationExternalid).subscribe(
        (data) => {
          this.responseSuccessful("Externalid is edited!");
          this.resetEdit();
          this.loadExternalids();
        },
        (error) => this.showErrorMessage(error),
      );
    } else {
      this.classificationExternalidControllerService.createClassificationExternalid(this.classificationTypeId, classificationExternalid).subscribe(
        (data) => {
          this.responseSuccessful("Externalid is edited!");
          this.resetEdit();
          this.loadExternalids();
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public deleteClassificationExternalid(isConfirmed: boolean, externalid: ClassificationExternalid) {
    if (isConfirmed) {
      this.classificationExternalidControllerService.deleteClassificationExternalid(externalid.id).subscribe(
        (data) => {
          this.responseSuccessful("Externalid is deleted!");
          this.loadExternalids();
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public sortTable(columnId) {
    if (this.sortOrder.columnId === columnId) {
      this.sortOrder.asc = !this.sortOrder.asc;
    } else {
      this.sortOrder.columnId = columnId;
      this.sortOrder.asc = false;
    }
    const groupItem = this.groups.find((el) => {
      return el.id === columnId;
    });
    groupItem.sortDir = this.sortOrder.asc ? "asc" : "desc";

    this.classificationFields.sort((fieldA, fieldB) => {
      let fieldAStatus = 0;
      let fieldBStatus = 0;
      fieldA.classificationGroups.forEach((group) => {
        if (group.id === columnId) {
          fieldAStatus = 1;
        }
      });
      fieldB.classificationGroups.forEach((group) => {
        if (group.id === columnId) {
          fieldBStatus = 1;
        }
      });
      if (this.sortOrder.asc) {
        return (fieldAStatus - fieldBStatus);
      } else {
        return (fieldBStatus - fieldAStatus);
      }
    });
  }

  public sortTableEIDs(columnId) {
    if (this.sortIDsOrder.columnId === columnId) {
      this.sortIDsOrder.asc = !this.sortIDsOrder.asc;
    } else {
      this.sortIDsOrder.columnId = columnId;
      this.sortIDsOrder.asc = false;
    }
    const eidItem = this.externalids.find((el) => {
      return el.id === columnId;
    });
    eidItem.sortDir = this.sortIDsOrder.asc ? "asc" : "desc";
    this.classificationFields.sort((fieldA, fieldB) => {
      let fieldAStatus = null;
      let fieldBStatus = null;
      fieldA.classificationFieldExternalIdList.forEach((group) => {
        if (group.externalIdId === columnId) {
          fieldAStatus = group.value;
        }
      });
      fieldB.classificationFieldExternalIdList.forEach((group) => {
        if (group.externalIdId === columnId) {
          fieldBStatus = group.value;
        }
      });
      if (this.sortIDsOrder.asc) {
        return (fieldAStatus - fieldBStatus);
      } else {
        return (fieldBStatus - fieldAStatus);
      }
    });
  }

  public moveToTop(elem) {
    /*
    for (let f = 0; f < this.classificationFields.length; f++) {
      if (this.classificationFields[f].id === elem) {
        this.classificationFields.unshift(this.classificationFields[f]);
        this.classificationFields.splice(f + 1, 1);
        break;
      }
    }
    */
    elem.customOrder = 0;
    this.updateClassificationField(elem, true);
  }

  public moveToBottom(elem) {
    elem.customOrder = this.totalUnfilteredFieldsCount + 1;
    /*
    for (let f = 0; f < this.classificationFields.length; f++) {
      if (this.classificationFields[f].id === elem) {
        this.classificationFields.push(this.classificationFields[f]);
        this.classificationFields.splice(f, 1);
        break;
      }
    }
    this.saveClassificationFields();
    */
    this.updateClassificationField(elem, true);
  }

  public setSorting(groups, ind) {
    groups.forEach((group, inde) => {
      group.sorting = inde === ind ? inde : -1;
    });
  }

  public sortExternalIds() {
    this.classificationExternalidControllerService.updateSortOrder(this.externalids).subscribe(
      (data) => {
        this.responseSuccessful("External IDs reordered!");
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public sortGroups() {
    this.classificationGroupControllerService.updateSortOrder(this.groups).subscribe(
      (data) => {
        this.responseSuccessful("Groups are reordered!");
        this.loadGroups();
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public clearSort() {
    this.sortOrder.columnId = "";
    this.sortOrder.asc = false;
    this.classificationFields.sort((fieldA, fieldB) => {
      return (fieldA.customOrder - fieldB.customOrder);
    });
  }

  public openEdit(group) {
    this.editInitialName = group.name;
    this.editMode = group.id;
  }

  public cancelEdit(group) {
    group.name = this.editInitialName;
    this.resetEdit();
  }

  public resetEdit() {
    this.editInitialName = "";
    this.editMode = "";
  }

  public searchTextChanged() {
    const filter = {value: this.searchValue};
    this.searchTextFilterObject = filter;
  }

  public resetSearch() {
    this.searchValue = "";
    this.searchTextFilterObject = null;
  }

  public searchServiceChanged(event) {
    const filter = {name: this.searchService};
    this.searchServiceFilterObject = filter;
  }

  public resetServiceSearch() {
    this.searchService = "";
    this.searchServiceFilterObject = null;
  }

  public scrollToTop() {
    window.scrollTo(0, 0);
    }

    public onResized(event: ResizedEvent) {
        this.contentWidth = (132 * this.groups.length) + (7 * (this.groups.length - 1));
    }

    public onFakeScroll(event): void {
        if (!this.isScrolled) {
            this.isScrolled = true;
            this.elementScroll.nativeElement.scrollLeft = event.srcElement.scrollLeft;
            this.isScrolled = false;
        }
    }

    public onScroll(event): void {
        if (!this.isScrolled) {
            this.isScrolled = true;
            this.fakeScroll.nativeElement.scrollLeft = event.srcElement.scrollLeft;
            this.isScrolled = false;
        }
    }

    public sortItems(key: string): void {
        this.alphabeticalOrderReference[key] = !this.alphabeticalOrderReference[key];
        this.lastOrder = Object.assign([], this.classificationFields);
        this.classificationFields.sort((fieldA, fieldB) => {
            return this.alphabeticalOrderReference[key]
                ? (fieldA[key].toLowerCase() > fieldB[key].toLowerCase() ? -1 : 1)
                : (fieldA[key].toLowerCase() > fieldB[key].toLowerCase() ? 1 : -1);
        });
        this.saveFieldsOrder();
    }

    public revertSort() {
        this.classificationFields = this.lastOrder;
        this.lastOrder = null;
        this.saveFieldsOrder();
    }

    private saveFieldsOrder(): void {
        if (this.isLoading) { return; }
        this.isLoading = true;
        // Account for page offset so customOrder values don't collide across pages
        const offset = (this.fieldsPage - 1) * this.fieldsPageSize;
        this.classificationFields.forEach((f, i) => f.customOrder = offset + i);

        const requests = this.classificationFields.map(field =>
          this.classificationControllerService.saveDocumentClassificationField(this.classificationTypeId, field)
        );
        forkJoin(requests).subscribe(
          () => {
            this.responseSuccessful("Items reordered!");
            this.loadClassificationFields();
          },
          (error) => { this.showErrorMessage(error); this.loadClassificationFields(); },
          () => { this.isLoading = false; }
        );
    }

    public toggleFilters(event) {
      this.isDrawerClosed = !this.isDrawerClosed;
    }

    public doubleScroll(element) {
      if (document.getElementById("top-scrollbar")) {
        document.getElementById("top-scrollbar").remove();
      }
      // Create a scrollbar element
      const scrollbar = document.createElement("div") as HTMLElement;
      const scrollbarContent = document.createElement("div") as HTMLElement;
      scrollbar.setAttribute("id", "top-scrollbar");
      scrollbar.appendChild(scrollbarContent);
      scrollbar.style.overflow = "auto";
      scrollbar.style.overflowY = "hidden";
      scrollbarContent.style.width = element.scrollWidth + "px";
      scrollbarContent.style.paddingTop = "1px";
      scrollbarContent.appendChild(document.createTextNode("\xA0"));
      let running = false;
      // Keep scrollbar in sync when element size changes
      new (window as any).ResizeObserver(() => {
        scrollbarContent.style.width = element.scrollWidth + "px";
      }).observe(element);
      scrollbar.onscroll = () => {
        if (running) {
          running = false;
          return;
        }
        running = true;
        element.scrollLeft = scrollbar.scrollLeft;
      };
      element.onscroll = () => {
        if (running) {
          running = false;
          return;
        }
        running = true;
        scrollbar.scrollLeft = element.scrollLeft;
      };
      element.parentNode.insertBefore(scrollbar, element);
    }

  public getPageNumber() {
    const pages = [];
    let index = 1;
    for (let i = 0; i <= this.fieldsAllItems - 1; i += this.fieldsPageSize) {
      pages.push(index);
      index++;
    }
    return pages;
  }

  public goToPage(page: number) {
    if (page >= 1 && page <= this.getPageNumber().length) {
      this.fieldsPage = page;
      this.loadClassificationFields();
    }
  }

  public onPageSizeChange(): void {
    this.fieldsPage = 1;
    this.loadClassificationFields();
    this.allFieldsLoaded = false;
  }

  public onFilterChange() {
    // Reset to first page when filter changes
    this.fieldsPage = 1;
    // Debounce the filter to avoid too many API calls
    if (this.filterTimeout) {
      clearTimeout(this.filterTimeout);
    }
    this.filterTimeout = setTimeout(() => {
      this.loadClassificationFields();
    }, 500);
  }

  public clearFilter() {
    this.catPageFilter = null;
    this.fieldsPage = 1;
    this.loadClassificationFields();
  }

  private filterTimeout: any;

  /**
   * Opens the usages drawer for a catalog from the list view
   */
  public openCatalogUsages(catalog: ClassificationType): void {
    this.selectedCatalogForUsages = catalog;
    this.showUsagesDrawer = true;
    this.loadCatalogUsages(catalog.id);
  }

  /**
   * Loads usages for a catalog from the detail view
   */
  public loadDetailUsages(): void {
    if (this.selectedClassificationType?.id) {
      this.showUsagesSection = !this.showUsagesSection;
      if (this.showUsagesSection && this.catalogUsages.length === 0) {
        this.loadCatalogUsages(this.selectedClassificationType.id);
      }
    }
  }

  /**
   * Called when the Usages tab is selected
   */
  public onUsagesTabSelected(): void {
    if (this.selectedClassificationType?.id && this.catalogUsages.length === 0) {
      this.loadCatalogUsages(this.selectedClassificationType.id);
    }
  }

  /**
   * Loads catalog usages from cache or API
   */
  private loadCatalogUsages(catalogId: string): void {
    // Check cache first
    if (this.usagesByCatalogIdCache[catalogId]) {
      this.catalogUsages = this.usagesByCatalogIdCache[catalogId];
      this.loadServiceNames();
      this.buildGroupedUsages();
      this.loadingUsages = false;
      return;
    }

    // Only fetch if not cached
    this.loadingUsages = true;
    this.catalogUsages = [];
    this.groupedUsages = [];
    this.classificationControllerService.getClassificationUsages([catalogId]).subscribe(
      (data: CatalogUsage[]) => {
        this.usagesByCatalogIdCache[catalogId] = data;
        this.catalogUsages = data;
        this.loadServiceNames();
        this.buildGroupedUsages();
        this.loadingUsages = false;
      },
      (error) => {
        this.showErrorMessage(error);
        this.loadingUsages = false;
      }
    );
  }

  /**
   * Load service names for all service IDs in catalog usages
   */
  private loadServiceNames(): void {
    const serviceIds = new Set<string>();
    this.catalogUsages.forEach(usage => {
      if (usage.serviceId && !this.serviceNamesCache[usage.serviceId]) {
        serviceIds.add(usage.serviceId);
      }
    });

    serviceIds.forEach(serviceId => {
      this.serviceControllerService.getService(serviceId).subscribe(
        (service: any) => {
          this.serviceNamesCache[serviceId] = service.name || serviceId;
        },
        () => {
          // If error, use serviceId as fallback
          this.serviceNamesCache[serviceId] = serviceId;
        }
      );
    });
  }

  /**
   * Get service name from cache or return ID as fallback
   */
  public getServiceName(serviceId: string): string {
    return this.serviceNamesCache[serviceId] || serviceId;
  }

  /**
   * Toggle usages section open/closed state
   */
  public toggleUsagesSection(key: string): void {
    if (this.usagesSectionsOpen[key] === undefined) {
      this.usagesSectionsOpen[key] = false; // First click closes it (was open by default)
    } else {
      this.usagesSectionsOpen[key] = !this.usagesSectionsOpen[key];
    }
  }

  /**
   * Check if usages section is open (default is true/open)
   */
  public isUsagesSectionOpen(key: string): boolean {
    return this.usagesSectionsOpen[key] !== false;
  }

  /**
   * Returns color-coded badge class based on usage type
   */
  public getUsageBadgeClass(usage: CatalogUsage): string {
    if (usage.formId) {
      return 'badge-primary';
    } else if (usage.determinantId) {
      return 'badge-info';
    } else if (usage.parentCatalogId) {
      return 'badge-warning';
    }
    return 'badge-secondary';
  }

  /**
   * Returns the usage type label
   */
  public getUsageTypeLabel(usage: CatalogUsage): string {
    if (usage.formId) {
      return 'Form';
    } else if (usage.determinantId) {
      return 'Determinant';
    } else if (usage.parentCatalogId) {
      return 'Parent catalog';
    }
    return '';
  }

  /**
   * Get usages filtered by type (deduplicated)
   */
  public getFormUsages(): CatalogUsage[] {
    const formUsages = this.catalogUsages.filter(u => u.formId);
    const seen = new Set<string>();
    return formUsages.filter(u => {
      const key = `${u.formId}-${u.componentKey || ''}`;
      if (seen.has(key)) {return false;}
      seen.add(key);
      return true;
    });
  }

  public getDeterminantUsages(): CatalogUsage[] {
    const detUsages = this.catalogUsages.filter(u => u.determinantId);
    const seen = new Set<string>();
    return detUsages.filter(u => {
      if (seen.has(u.determinantId)) {return false;}
      seen.add(u.determinantId);
      return true;
    });
  }

  public getParentCatalogUsages(): CatalogUsage[] {
    const parentUsages = this.catalogUsages.filter(u => u.parentCatalogId);
    const seen = new Set<string>();
    return parentUsages.filter(u => {
      const key = `${u.parentCatalogId}-${u.parentCatalogFieldId || ''}`;
      if (seen.has(key)) {return false;}
      seen.add(key);
      return true;
    });
  }

  /**
   * Get usages grouped by service, then by type, then by form (for form usages)
   */
  private buildGroupedUsages(): void {
    const serviceMap: { [serviceId: string]: {
      serviceId: string;
      serviceName: string;
      formsMap: { [formId: string]: { formId: string; formName: string; formType: string; usages: CatalogUsage[] } };
      determinantsSet: Set<string>;
      determinants: CatalogUsage[];
      parentCatalogsSet: Set<string>;
      parentCatalogs: CatalogUsage[];
    }} = {};

    this.catalogUsages.forEach(usage => {
      const serviceId = usage.serviceId || 'unknown';
      if (!serviceMap[serviceId]) {
        serviceMap[serviceId] = {
          serviceId,
          serviceName: serviceId, // Will use serviceId as name for now
          formsMap: {},
          determinantsSet: new Set(),
          determinants: [],
          parentCatalogsSet: new Set(),
          parentCatalogs: []
        };
      }

      const service = serviceMap[serviceId];

      if (usage.formId) {
        const formKey = usage.formId;
        if (!service.formsMap[formKey]) {
          service.formsMap[formKey] = {
            formId: usage.formId,
            formName: usage.formName || 'Unknown',
            formType: usage.formType || '',
            usages: []
          };
        }
        // Deduplicate by componentKey
        const componentKey = `${usage.formId}-${usage.componentKey || ''}`;
        const existingKeys = service.formsMap[formKey].usages.map(u => `${u.formId}-${u.componentKey || ''}`);
        if (!existingKeys.includes(componentKey)) {
          service.formsMap[formKey].usages.push(usage);
        }
      } else if (usage.determinantId) {
        if (!service.determinantsSet.has(usage.determinantId)) {
          service.determinantsSet.add(usage.determinantId);
          service.determinants.push(usage);
        }
      } else if (usage.parentCatalogId) {
        const parentKey = `${usage.parentCatalogId}-${usage.parentCatalogFieldId || ''}`;
        if (!service.parentCatalogsSet.has(parentKey)) {
          service.parentCatalogsSet.add(parentKey);
          service.parentCatalogs.push(usage);
        }
      }
    });

    this.groupedUsages = Object.values(serviceMap).map(service => ({
      serviceId: service.serviceId,
      serviceName: service.serviceName,
      forms: Object.values(service.formsMap),
      determinants: service.determinants,
      parentCatalogs: service.parentCatalogs
    }));
  }

  /**
   * Get total unique usages count for a service
   */
  public getServiceUsagesCount(service: { forms: { usages: CatalogUsage[] }[]; determinants: CatalogUsage[]; parentCatalogs: CatalogUsage[] }): number {
    const formsCount = service.forms.reduce((sum, f) => sum + f.usages.length, 0);
    return formsCount + service.determinants.length + service.parentCatalogs.length;
  }

  /**
   * Get total deduplicated usages count across all services
   */
  public getTotalUsagesCount(): number {
    return this.groupedUsages.reduce((total, service) => total + this.getServiceUsagesCount(service), 0);
  }

  /**
   * Get total usages count across all forms in a service
   */
  public getFormsUsagesCount(forms: { usages: CatalogUsage[] }[]): number {
    return forms.reduce((sum, f) => sum + f.usages.length, 0);
  }

  /**
   * Close usages drawer
   */
  public closeUsagesDrawer(): void {
    this.showUsagesDrawer = false;
    this.selectedCatalogForUsages = null;
    this.catalogUsages = [];
  }

  /**
   * Map form type to the URL path used in routing
   * Form paths must match ApplicationFileFormsContainer.formPaths
   */
  private getFormPathFromType(formType: string): string {
    if (!formType) {
      return null;
    }
    const formTypeUpper = formType.toUpperCase();
    const formTypeMap: { [key: string]: string } = {
      GUIDEFORM: "guide-form",
      GUIDE: "guide-form",
      "GUIDE-FORM": "guide-form",
      APPLICANTFORM: "applicant-form",
      APPLICANT: "applicant-form",
      "APPLICANT-FORM": "applicant-form",
      FORM: "applicant-form",
      DOCUMENTFORM: "document-form",
      DOCUMENT: "document-form",
      "DOCUMENT-FORM": "document-form",
      PAYMENTFORM: "payment",
      PAYMENT: "payment",
      SENDPAGEFORM: "sendfile",
      SENDPAGE: "sendfile",
      SENDFILE: "sendfile",
    };
    return formTypeMap[formTypeUpper] || null;
  }

  /**
   * Generate the appropriate route URL for a catalog usage
   * Returns null if no valid route can be generated
   */
  public getUsageRouteUrl(usage: CatalogUsage): string {
    const baseUrl = window.location.origin;

    if (usage.formType && usage.componentKey) {
      // Form usage - navigate to form with component highlighted via hash fragment
      // The URL path must use form path (e.g., "guide-form") not a custom form ID
      const formPath = this.getFormPathFromType(usage.formType);
      if (formPath) {
        return `${baseUrl}/services/${usage.serviceId}/forms/${formPath}#${usage.componentKey}`;
      }
      return null;
    } else if (usage.determinantId) {
      // Determinant usage - navigate to determinants table with item selected via hash
      return `${baseUrl}/services/${usage.serviceId}/determinantstable#${usage.determinantId}`;
    } else if (usage.parentCatalogId) {
      // Parent catalog usage - navigate to parent catalog
      // Use service-specific route if serviceId available, otherwise global route
      const base = usage.serviceId
        ? `${baseUrl}/services/${usage.serviceId}/variables/instance-catalogs/${usage.parentCatalogId}`
        : `${baseUrl}/variables/instance-catalogs/${usage.parentCatalogId}`;

      if (usage.parentCatalogFieldId) {
        return `${base}?highlightField=${usage.parentCatalogFieldId}`;
      }
      return base;
    }
    return null;
  }

  /**
   * Open the usage location in a new browser tab
   */
  public openUsageInNewTab(usage: CatalogUsage): void {
    const url = this.getUsageRouteUrl(usage);
    if (url) {
      window.open(url, '_blank');
    }
  }

  protected readonly window = window;
}
